import { IonPage, IonInput, IonButton, IonSlides, IonGrid, IonItem, IonTabs, IonTabBar, IonTabButton, IonMenu, IonToolbar, IonTitle, IonContent, IonList, IonHeader, IonMenuToggle, IonLabel, IonSplitPane, IonRouterOutlet, IonFooter, IonModal, IonText, IonDatetime, IonRefresher, IonRefresherContent } from '@ionic/react';
import { IonSlide, IonRow, IonCol, IonIcon, IonButtons, IonMenuButton, IonImg } from '@ionic/react';
import { Link, Router, Redirect, Route, Switch } from "react-router-dom";
import React, {useState, useContext, useEffect} from 'react';

import '../../../css/layout.css';

import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';

import { ViewReservationsModal } from './Modal_ViewReservations';
import { Reservation_EnterBookingInfo } from './Reservation_EnterBookingInfo';

import {DateRange} from '../../../zInternal_Features/merchant/components/DateRange'

export function ReservationSlides (props){

    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);

    const [acctID, setAcctID ] = useState(authenticatedMerchent_context.acctID);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);

    let [startDate, setStartDate] = useState(new Date(new Date().setDate(new Date().getDate())));
    let [endDate, setEndDate] = useState(new Date(new Date().setDate(new Date().getDate()+30)));

    let [startDate_display, setStartDate_display] = useState(false);
    let [endDate_display, setEndDate_display] = useState(false);

    let [inputReservationInfoModal, setInputReservationInfoModal] = useState(false);

    let [numOnlineReservations, setNumOnlineReservations ] = useState(null);
    let [numPhoneReservations, setNumPhoneReservations ] = useState(null);
    let [numIn_personReservations, setNumIn_personReservations ] = useState(null);

    let [checkInRoomID, setCheckInRoomID ] = useState(null);
    let [roomSalePrice, setRoomSalePrice ] = useState(null);

    let [showReservedRoomsModal , setShowReservedRoomsModal] = useState(false);
    let [viewTracker, setViewTracker] = useState(null);


    function reloadDates(event)
    {

        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            //body: JSON.stringify({formData})
            body: JSON.stringify({
                Tracker: 74700,
                user: acctID,
                xStartDateRange: event[0],
                xEndDateRange: event[1],
                sessionID: sessionID,
            })
        }

        fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(res => {

            let rows = res.toString().split('~~~');
            let rowLength = rows.length;

                for (let rownum = 0; rownum < rowLength - 1; ++rownum)
                {
                    let cols = rows[rownum].split('|');

                    /*alert('In Reservations UseEffect');
                    alert(cols[0]);
                    alert(cols[1]);
                    alert(cols[2]);*/

                    setNumOnlineReservations(cols[0]);
                    setNumPhoneReservations(cols[1]);
                    setNumIn_personReservations(cols[2]);
                }
                authenticatedMerchent_context.changeStartDateRange(event[0]);
                authenticatedMerchent_context.changeEndDateRange(event[1]);

                setStartDate(new Date(event[0]));
                setEndDate(new Date(event[1]));
        })
    }


    function viewReservations_online() {

        setViewTracker(74702);
        setShowReservedRoomsModal(true); 
    }

    function viewReservations_phone() {

        setViewTracker(74703);
        setShowReservedRoomsModal(true); 
    }

    function viewReservations_inPerson() {

        setViewTracker(74704);
        setShowReservedRoomsModal(true);
    }

    function onCheckInRoomIDHandler(event) {



    setCheckInRoomID(event.selectedRoomID);

    }

    function handleRefresh(event)
    {
        // Optional: Delay to show the spinner briefly
        setTimeout(() => {
            event.detail.complete();   // Stop the spinner
            window.location.reload();  // Reload the entire app
        }, 500);
    }

useEffect(() => {

        reloadDates([startDate.toISOString().substr(0, 10), endDate.toISOString().substr(0, 10)]);

   }, []);

        return (
            <React.Fragment>

            <IonContent className='appContent'>
            <IonRefresher slot="fixed" onIonRefresh={handleRefresh}>
                <IonRefresherContent
                pullingText="Pull to refresh the app"
                refreshingSpinner="circles"
                refreshingText="Refreshing app..."
                />
            </IonRefresher>
                <IonItem>
                    <IonGrid>
                            <DateRange setDate={(e) => reloadDates(e)} data={{
                            startDate: startDate, 
                            endDate: endDate
                            }}></DateRange>
                    </IonGrid>
                </IonItem>

                <IonGrid >
                    <IonRow>
                        <IonCol>
                            <h3>Reservations</h3>
                            <p > {numOnlineReservations} </p>
                            <IonButton onClick={viewReservations_online}> View </IonButton>
                        </IonCol>
                    </IonRow>
                    {/*<IonRow>
                        <IonCol>
                            <h3>Phone Reservations</h3>
                            <p >  {numPhoneReservations} </p>
                            <IonButton onClick={viewReservations_phone}> View </IonButton>
                        </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol>
                            <h3>In-person Reservations</h3>
                            <p >  {numIn_personReservations} </p>
                            <IonButton onClick={viewReservations_inPerson}> View </IonButton>
                        </IonCol>
                    </IonRow>*/}
                    <IonRow>
                        <IonCol class="styleButton">
                            <IonButton onClick={() => setInputReservationInfoModal(true)}> New Reservation </IonButton>
                        </IonCol>
                    </IonRow>
                </IonGrid>

                {showReservedRoomsModal == true && <ViewReservationsModal openModal={ showReservedRoomsModal } closeModal={() => setShowReservedRoomsModal(false)} startDate={authenticatedMerchent_context.startDate} endDate={authenticatedMerchent_context.endDate} tracker={viewTracker}></ViewReservationsModal>}


                { inputReservationInfoModal == true &&
                    <Reservation_EnterBookingInfo openModal={ inputReservationInfoModal } closeModal={() => setInputReservationInfoModal(false)}  tracker={74701} data={{
                    roomID: '', 
                    roomSalePrice: ''
                    }}> </Reservation_EnterBookingInfo>
                }

            </IonContent>
            </React.Fragment>
        )
}